export default function CabinetsShowcase() {
  return (
    <section id="cabinets" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/119f75b3e0ec65292122f773a0c5b92e.jpg"
          alt="Fine Frank Cabinets"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between p-16">
        {/* Title */}
        <div className="pt-12">
          <h2 className="text-7xl font-bold text-white capitalize">
            Fine Frank Cabinets
          </h2>
        </div>

        {/* Bottom Content */}
        <div className="flex justify-between items-end">
          {/* CTA Button */}
          <a 
            href="#contact"
            className="flex items-center gap-4 bg-white rounded-full pl-8 pr-2 py-2 hover:bg-gray-100 transition-colors cursor-pointer group"
          >
            <span className="text-gray-900 font-semibold whitespace-nowrap">Explore Cabinets</span>
            <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center group-hover:bg-gray-800 transition-colors">
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </div>
          </a>

          {/* Description */}
          <div className="text-right">
            <p className="text-white text-lg font-light">
              Custom design, manufacturing, assembly<br />
              and installation of premium cabinetry
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}